import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '@/store/authStore';

interface ParentOnlyRouteProps {
  children: React.ReactNode;
}

const ParentOnlyRoute: React.FC<ParentOnlyRouteProps> = ({ children }) => {
  const user = auth.getUser();
  if (user.role !== 'parent') {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default ParentOnlyRoute;
